import React from "react";
import "../Css/ourhome.css";
import ForestImg from "../Img/Final-images/Forest View.jpeg";
import SpringImg from "../Img/Final-images/Spring House.jpeg";
import RiseImg from "../Img/Final-images/Rise House.jpeg";
import { Link } from "react-router-dom";
import BannerImg from "../Img/Final-images/ourhome-banner_n.jpg";

const forestHomes = [
  {
    id: "forestView",
    title: "Forest View",
    desc: "Forest View is an Ofsted registered residential children’s home operated by Affinity Children’s Services Limited.",
    img: ForestImg,
  },
  {
    id: "springhouse",
    title: "Spring House",
    desc: "Spring House is an Ofsted registered residential children’s home operated by Affinity Children’s Services Limited.",
    img: SpringImg,
  },
  {
    id: "risehouse",
    title: "Rise House",
    desc: "Rise House is an Ofsted registered residential children’s home operated by Affinity Children’s Services Limited.",
    img: RiseImg,
  },
];

function Ourhome() {
  return (
    <>
      {/* Banner Section */}
      <section className="Ourhom text-center mobile-view">
        <div>
          <img src={BannerImg} className="w-100" />
        </div>
        <div className="container mobile-view-none">
          <div className="breadcrumb-container" aria-label="Breadcrumb">
            <ul className="breadcrumbs">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li aria-current="page">Our Homes</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-5">
        <div className="container">
          <h2 className="sub-heading text-center">
            A Place That Feels Like Family
          </h2>
          <p className="text-center pb-4">
            Our home is built on love, safety, and strong support. We help
            children feel comfortable, confident, and cared for. With a balanced
            routine and friendly guidance, they grow happily. Every child is
            treated with the warmth of a family.
          </p>

          <p className="text-center">
            All of our homes are large, detached properties and based in local
            communities. This ensures that children and young people in our care
            have access to local amenities, giving them the same life chances as
            other young people in the area.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="homes-section py-5">
        <div className="container">
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-10">
              <h2 className="fw-bold mb-3">Our Residential Homes</h2>
              <p>
                Affinity Children’s Services Limited operates a small number of
                residential children’s homes, each registered with Ofsted.
              </p>
            </div>
          </div>

          <div className="row g-4 justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="home-feature text-center p-4 h-100">
                <div className="home-icon mb-3">🏡</div>
                <h5>Homely Environment</h5>
                <p className="mb-0">
                  Provides care in a nurturing and welcoming home setting.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="home-feature text-center p-4 h-100">
                <div className="home-icon mb-3">👨‍💼</div>
                <h5>Experienced Manager</h5>
                <p className="mb-0">
                  Each home is led by a qualified and experienced Registered
                  Manager.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="home-feature text-center p-4 h-100">
                <div className="home-icon mb-3">📋</div>
                <h5>Statement of Purpose</h5>
                <p className="mb-0">
                  Operates under its own clear Statement of Purpose and care
                  policies.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="home-feature text-center p-4 h-100">
                <div className="home-icon mb-3">❤️</div>
                <h5>Individual Care Planning</h5>
                <p className="mb-0">
                  Supports children through personalised and individual care
                  plans.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Homes List Section */}
      <section className="homes-section py-5">
        <div className="container">
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-10">
              <h2 className="fw-bold mb-3">Our Homes</h2>
              <p className="text-center">
                Affinity Children’s Services Limited operates a small number of
                residential children’s homes, each registered with Ofsted.
              </p>
            </div>
          </div>

          <div className="row g-4 justify-content-center">
            {forestHomes.map((home) => (
              <div key={home.id} className="col-lg-4 col-md-6">
                <Link
                  to={`/ourhome/${home.id}`}
                  className="text-decoration-none text-dark"
                >
                  <div className="home-feature h-100 text-center">
                    <div className="Forest-View">
                      <img
                        src={home.img}
                        className="w-100"
                        alt={`${home.title} residential home`}
                        loading="lazy"
                      />
                    </div>

                    <div className="p-4">
                      <h5>{home.title}</h5>
                      <p className="mb-0">{home.desc}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Ourhome;
